export class LocalStoreService<T> {
    private localStorageKey: string;
    constructor(key: string) {
        this.localStorageKey = key;
    }

    set(val: T) {
        const value = JSON.stringify(val);
        localStorage.setItem(this.localStorageKey, value);
    }

    get(): T {
        try {
            const val: T = JSON.parse(localStorage.getItem(this.localStorageKey));
            return val;
        } catch {
            return undefined;
        }
    }
}
